module.exports = __webpack_public_path__ + "static/media/grtextile.4efc7cb4.PNG";